import SimpleQuestion from "./SimpleQuestion";
import { NumericFormat } from "react-number-format";
import * as theme from "../theme";
import { INSURER } from "../store/businesslogic/hardwiredlogic";

const MultiString = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
}) => {
  return (
    <SimpleQuestion
      alignCenter={"No"}
      leftString={text}
      node={node}
      rightComponent={
        <ContactNumberInput
          node={node}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
        ></ContactNumberInput>
      }
    ></SimpleQuestion>
  );
};

const ContactNumberInput = ({ node, handleAnswerChange, qfusermode }) => {
  let n = node?.logic?.n;

  if (isNaN(n) || Number(n) <= 0) n = 1;

  let narray = Array.from(Array(Number(n)).keys());

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      {narray.map((item) => (
        <EachInput
          key={item}
          node={node}
          handleAnswerChange={handleAnswerChange}
          index={item}
          qfusermode={qfusermode}
        ></EachInput>
      ))}
    </div>
  );
};

const EachInput = ({ node, handleAnswerChange, index, qfusermode }) => {
  const handleAnswer = (event) => {
    if (node.answer) {
      handleAnswerChange({ ...node.answer, [index + 1]: event.target.value });
      return;
    }

    handleAnswerChange({ [index + 1]: event.target.value });
  };
  return (
    <div style={{ marginBottom: "0.5vh" }}>
      <input
        type="text"
        placeholder={`${index + 1}.`}
        id={"numberInput" + node.id + index}
        style={{ ...theme.inputStyle }}
        value={
          node.answer
            ? node.answer[index + 1]
              ? node.answer[index + 1]
              : ""
            : ""
        }
        onChange={handleAnswer}
        readOnly={qfusermode === INSURER ? true : false}
      ></input>
    </div>
  );
};

export default MultiString;
